export default __webpack_public_path__ + "static/media/BankAcc.59be81c2.svg";